import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ApproveCampaignRequest, Campaign } from '@seo/types';
import { apiPost } from '@/lib/api';

export function useApproveCampaign(campaignId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ApproveCampaignRequest = {}) =>
      apiPost<Campaign>(`/v1/campaigns/${campaignId}/approve`, input),
    onSuccess: (c) => {
      qc.setQueryData(['campaign', campaignId], c);
      void qc.invalidateQueries({ queryKey: ['campaign-events', campaignId] });
    },
  });
}
